import * as React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'

interface DataTablePaginationProps {
  pageCount: number
  pageIndex: number
  onPageIndexChange: (pageIndex: number) => void
}

export function DataTablePagination({
  pageCount,
  pageIndex,
  onPageIndexChange,
}: DataTablePaginationProps) {
  const [goToPageInput, setGoToPageInput] = React.useState('')

  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPageInput, 10)
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount) {
      onPageIndexChange(pageNumber - 1) // Adjust to 0-based index
      setGoToPageInput('')
    } else {
      // Optionally provide feedback for invalid input
      console.error('Invalid page number')
    }
  }

  return (
    <div className='flex items-center justify-end px-2'>
      <div className='flex items-center space-x-4'>
        <div className='flex items-center space-x-2'>
          <Button
            variant='outline'
            className='h-8 w-8 p-0'
            onClick={() => {
              if (pageIndex > 0) {
                onPageIndexChange(pageIndex - 1)
              }
            }}
            disabled={pageIndex === 0}
          >
            <ChevronLeftIcon className='h-4 w-4' />
          </Button>
          <span className='text-sm text-muted-foreground'>
            Page {pageIndex + 1} of {pageCount}
          </span>
          <Button
            variant='outline'
            className='h-8 w-8 p-0'
            onClick={() => {
              if (pageIndex < pageCount - 1) {
                onPageIndexChange(pageIndex + 1)
              }
            }}
            disabled={pageIndex === pageCount - 1}
          >
            <ChevronRightIcon className='h-4 w-4' />
          </Button>
        </div>
        <div className='flex items-center space-x-2'>
          <Input
            type='number'
            className='h-8 w-16 text-sm'
            placeholder='Go to page...'
            value={goToPageInput}
            onChange={(e) => setGoToPageInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleGoToPage()
              }
            }}
          />
          <Button onClick={handleGoToPage} size='sm'>
            Go
          </Button>
        </div>
      </div>
    </div>
  )
}
